import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";


import { doService } from "../../services/ServiceHelper";  
import { updateLocation } from "../../services/PassService";
import {
  StripedTableRow,
  StripedTableCell,
  StripedTableHeadCell,
} from "../../components/StripedTable";
import InlineEditableSelect from "../../components/InlineEditableSelect";

function PassDetailsDialog({ jwt, school, onClose, open, pass, allowToEdit = false, locations }) {
  const handleClose = (doReload=false) => {
    if (onClose) {
      onClose(doReload);
    }
  };

  const onChangeLocation = (value) => {
    doService(updateLocation(school, jwt, pass.eid, value), (results) => {
      // close immediately, since we don't want to wait for the API call to finish
      handleClose(true);
    });
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: 450,
          maxHeight: 330,
        },
      }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle id="select-student-list-dialog-title">
        Pass Details
      </DialogTitle>

      <DialogContent>
        <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
          <Table size="small">
            <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Student:</StripedTableHeadCell>
                <StripedTableCell>
                  {pass.student_last_name}, {pass.student_first_name}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Status:</StripedTableHeadCell>
                <StripedTableCell>{pass.statusText}</StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>To:</StripedTableHeadCell>
                <StripedTableCell>
                  {pass.to_location_name != null && (
                    <>
                      {allowToEdit && (
                        <>
                          <InlineEditableSelect
                            value={pass.to_location_id}
                            options={locations}
                            onChange={(value) => onChangeLocation(value)}
                          />
                        </>
                      )}
                    </>
                  )}
                  {pass.to_location_name == null && (
                    <>
                      {pass.to_teacher_last_name},{" "}
                      {pass.to_teacher_first_name}
                    </>
                  )}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>From:</StripedTableHeadCell>
                <StripedTableCell>
                  {pass.teacher_last_name}, {pass.teacher_first_name}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Type:</StripedTableHeadCell>
                <StripedTableCell>{pass.type_name}</StripedTableCell>
              </StripedTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PassDetailsDialog;
